<template>
	<div v-if="category">
			<b-col cols="12">
					<h2>{{ $i18nHelpers.normalize(category.name) }}</h2>
			</b-col>
			<b-row class="neu-cards-ctn landing-cnt  mt-5" cols="1" cols-xl="4" v-if="microhabits.length > 0 && patientMicrohabits !== null">
					<div v-for="microhabit in microhabits" :key="microhabit.id" >
						<PatientPanelServiceBlock v-if="!getPatientMicrohabit(microhabit)" visible :id="microhabit.id" :title="$i18nHelpers.normalize(microhabit.name)" :description="getMicrohabitDescription(microhabit)" :action="() => { onBlockClick(category, microhabit) }" noBackgroundImage :class="{ 'taller-neu-card': !!getMicrohabitDescription(microhabit) }" :toggleableMobileDescription="isFoodMicrohabitType" :actionable="isFoodMicrohabitType">
							<template v-slot:icon>
								<img :src="getIcon(microhabit)" class="microhabits-icon"/>
							</template>
							<template v-slot:absolute-items v-if="!isFoodMicrohabitType">
								<BIconHeart class="position-absolute heart-microhabit" variant="primary" v-b-tooltip.hover="$t('microhabits.simple.panel-menu.add-to-my-habits')" @click.stop="addToFavorites(microhabit)"></BIconHeart>
							</template>
						</PatientPanelServiceBlock>
						<PatientMicrohabitBlock v-else :patientMicrohabit="getPatientMicrohabit(microhabit)" :mainCategory="category" showHeartIcon noBackgroundImage :type="type" @deleted="loadPatientMicrohabits"/>
					</div>
			</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import PatientMicrohabitBlock from '@/components/microhabits/PatientMicrohabitBlock'
import microhabitsMixin from '@/mixins/microhabits.mixin'
import { BIconHeart } from 'bootstrap-vue'

export default {
	mixins: [microhabitsMixin],
	components: {
		PatientPanelServiceBlock,
		PatientMicrohabitBlock,
		BIconHeart
	},
	data () {
		return {
			category: null,
			microhabits: [],
			patientMicrohabits: null
		}
	},
	methods: {
		getCoverImage (microhabit) {
			return microhabit.images[0]
		},
		getIcon (microhabit) {
			if (microhabit.images && microhabit.images.length > 0) {
				return microhabit.images[0]
			}
			return microhabit.icon || this.DEFAULT_MICROHABIT_IMAGE
		},
		getPatientMicrohabit (microhabit) {
			return this.patientMicrohabits.find((patientMicrohabit) => patientMicrohabit.microhabit.id === microhabit.id)
		},
		getPatientMicrohabitCategories (patientMicrohabit) {
			let categories = []
			this.patientMicrohabits.forEach((pf) => {
				if (pf.microhabit.id === patientMicrohabit.microhabit.id && pf.microhabitCategory.id !== this.category.id) {
					categories.push(pf.microhabitCategory)
				}
			})
			return categories
		},
		getMicrohabitDescription (microhabit) {
			return !this.isFoodMicrohabitType ? this.$i18nHelpers.normalize(microhabit.description || microhabit.defaultDescription) : null
		},
		onBlockClick (category, microhabit) {
			if (this.isFoodMicrohabitType) {
				this.goToMicrohabit(category.id, microhabit.id)
			}
			this.$emit('blockClick', { category, microhabit })
		},
		addToFavorites (microhabit) {
			// If patient is not subscriptor he cannot add microhabits to favorites
			if (!this.$store.getters['session/userHasCompanies']) {
				this.$store.dispatch('showOnlySubscriptorsDialog')
				return
			}
			// Check if patient has less than 5 microhabits achieved
			if (this.patientMicrohabits.filter((pm) => !pm.achieved).length < 5) {
				this.microhabitRepository.addPatientMicrohabit({
					microhabitId: microhabit.id,
					microhabitCategoryId: this.category.id
				}).then((response) => {
					this.loadPatientMicrohabits()
					this.$store.dispatch('showAlert', { text: this.$t('microhabits.simple.panel-menu.added-to-favourites'), variant: 'success' })
				})
			} else {
				this.$store.dispatch('showAlert', { text: this.$t('microhabits.simple.panel-menu.max-favourites-reached'), variant: 'danger' })
			}
		},
		loadPatientMicrohabits () {
			if (this.favoritesSectionActive) {
				this.microhabitRepository.getPatientMicrohabits().then((response) => {
					this.patientMicrohabits = response.data
					// Delete microhabits with same id and get an array
					/* this.uniquePatientMicrohabits = response.data.filter((patientMicrohabit, index, self) => self.findIndex((pf) => pf.microhabit.id === patientMicrohabit.microhabit.id) === index) */
				})
			} else {
				this.patientMicrohabits = []
			}
		}
	},
	mounted () {
		this.microhabitRepository.getMicrohabitCategory(this.$route.params.category).then((response) => {
			this.category = response.data
			this.$store.commit('microhabits/setCurrentCategory', this.category)
		})
		this.microhabitRepository.getMicrohabits(this.$route.params.category).then((response) => {
			this.microhabits = response.data
		})

		this.loadPatientMicrohabits()
	}
}
</script>

<style lang="scss" scoped>
@import '../../../static-appopensalud/css/webapp/foods-section.scss';

.heart-microhabit {
	top: 1.5rem;
	right: 3rem;
	z-index: 1;

	@include media(mobile, tablets) {
		top: 15px;
		right: 20px;
		font-size: 1.5rem;
	}
}

.microhabits-icon {
	border-radius: $border-radius;
	width: 110px;

	@include media(mobile, tablets) {
		margin-bottom: 1rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/microhabits/MicrohabitsPanelMenu.vue